import React from 'react';
//@ts-ignore
import * as styles from './filtered-content.module.css';
import { ContentPreview } from './index';
import { Faq as FaqType } from '../Global/DataUtils/faqQueries';
//@ts-ignore
import Faq, { isRenderableFaq } from '../Faq';
import { getMultiChoice } from '../Global/DataUtils';
import { KontentRadioMultiChoice } from '../../../types/KontentProps';

interface Props {
    content?: ContentPreview[];
    visibleCount?: number;
    maxShowInGrid?: number;
    useGrid?: KontentRadioMultiChoice<'grid' | 'stacked'>;
}

const FaqExploration: React.FC<Props> = ({
    content,
    visibleCount,
    maxShowInGrid,
    useGrid,
}) => {
    const faqs = (Array.isArray(content) ? content : []).filter(
        isRenderableFaq
    );
    const displayLimit =
        typeof visibleCount === 'number' && visibleCount >= 0
            ? visibleCount
            : faqs.length;

    const renderContent = (contentItem: FaqType, contentIdx: number) => {
        const gridSpan = maxShowInGrid && contentIdx < maxShowInGrid ? 1 : 3;

        return (
            <Faq
                key={contentItem.id || contentIdx}
                faq={contentItem}
                gridSpan={gridSpan}
                truncateBody={gridSpan === 1 ? false : true}
                isDisplayHidden={contentIdx >= displayLimit}
            />
        );
    };

    const faqsLayout = getMultiChoice(useGrid);

    return (
        <div
            className={`${styles.faq} ${
                faqsLayout === 'grid' ? styles.gridfaq : ''
            }`}
        >
            {faqs?.map((contentItem, itemIdx) =>
                renderContent(contentItem as FaqType, itemIdx)
            )}
        </div>
    );
};

export default FaqExploration;
